class LightBox{
  constructor(){
    let goto = this.goto;
    jQuery('a').click(function(e){
      if(jQuery(this).data('lightbox')){
        jQuery(jQuery(this).data('lightbox')).addClass('active');
        if(jQuery(this).data('lightbox-gallery') != undefined){
          console.log(jQuery(this).data('lightbox-gallery'));
          let current = jQuery(this);
          let lightbox = jQuery(this).data('lightbox');
          let search = 'a[data-lightbox-gallery='+jQuery(current).data('lightbox-gallery')+']';
          goto(current, lightbox, search);
        
          
          jQuery(lightbox).find('.icon-prev').click(function(){
            current = jQuery(current).prev(search);
            goto(current, lightbox, search);
          })
          jQuery(lightbox).find('.icon-next').click(function(){
            current = jQuery(current).next(search);
            goto(current, lightbox, search);
          })
        }
        e.preventDefault()
      }
    })
    jQuery('.lightbox .close-lightbox').click(function(e){
      jQuery(this).closest('.lightbox').removeClass('active');
      e.preventDefault
    })
    jQuery('.lightbox').click(function(e){
      if ( jQuery(e.target).hasClass('lightbox') ) { 
        jQuery(this).removeClass('active');
      }
    })
  }
  goto(current, lightbox, search){
    if(jQuery(current).next(search).length){ jQuery(lightbox).find('.icon-next').show(); } else { jQuery(lightbox).find('.icon-next').hide(); }
    if(jQuery(current).prev(search).length){ jQuery(lightbox).find('.icon-prev').show(); } else { jQuery(lightbox).find('.icon-prev').hide(); }
    let newInner = '<div class="photo"><img src="' + jQuery(current).attr('href') + '" /></div>';
    if(jQuery(current).data('caption')){
      newInner += '<p class="caption">'+ jQuery(current).data('caption') +'</p>'
    }
    console.log(newInner);
    jQuery(lightbox).find('.inner').html(newInner);
  }
}

export default LightBox;


// WEBPACK FOOTER //
// ./scripts/util/LightBox.js